import { styled as styledMui, Box } from "@mui/material";

export const StepperContainer = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "8px",
});

export const StepItem = styledMui(Box)<{ clickable?: boolean }>(
  ({ clickable }) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0,
    cursor: clickable ? "pointer" : "default",
  }),
);

type CircleState = "active" | "completed" | "pending";

export const StepCircle = styledMui(Box)<{ state: CircleState }>(({
  theme,
  state,
}) => {
  const activeColor = theme.palette.primary.main;
  const pendingColor = theme.palette.divider;

  if (state === "active") {
    return {
      width: "22px",
      height: "22px",
      borderRadius: "50%",
      border: `2px solid ${activeColor}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "transparent",
      flexShrink: 0,
      "&::before": {
        content: '""',
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: activeColor,
      },
    };
  }

  if (state === "completed") {
    return {
      width: "22px",
      height: "22px",
      borderRadius: "50%",
      backgroundColor: activeColor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.palette.primary.contrastText,
      flexShrink: 0,
    };
  }

  return {
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    backgroundColor: pendingColor,
    flexShrink: 0,
  };
});

export const StepConnector = styledMui(Box)(({ theme }) => ({
  flex: 1,
  height: "1px",
  backgroundColor: theme.palette.divider,
  minWidth: "24px",
}));
